import React from 'react';
import { BookOpen, ChevronRight } from 'lucide-react';
export function IncludesSection() {
  return <section className="w-full bg-gray-900 text-white py-16 px-4" data-id="element-119">
      <div className="max-w-4xl mx-auto" data-id="element-120">
        <div className="text-center mb-12" data-id="element-121">
          <h2 className="text-4xl md:text-5xl font-black text-yellow-400 uppercase tracking-wider mb-4" data-id="element-122">
            QUÉ INCLUYE
          </h2>
          <p className="text-2xl font-bold text-gray-300" data-id="element-123">
            📦 Esto es lo que recibirás
          </p>
        </div>

        <div className="bg-gray-800 rounded-2xl p-8 md:p-12 border border-gray-700 shadow-2xl relative overflow-hidden" data-id="element-124">
          {/* Decorative background element */}
          <div className="absolute top-0 right-0 -mt-10 -mr-10 text-gray-700 opacity-20" data-id="element-125">
            <BookOpen size={200} data-id="element-126" />
          </div>

          <div className="relative z-10" data-id="element-127">
            <div className="flex items-center mb-6" data-id="element-128">
              <span className="text-4xl mr-4" data-id="element-129">📘</span>
              <h3 className="text-2xl md:text-3xl font-bold text-white" data-id="element-130">
                Ebook principal:{' '}
                <span className="text-yellow-400" data-id="element-131">
                  Kit de Aprendizaje en Casa
                </span>
              </h3>
            </div>

            <p className="text-xl text-gray-300 mb-8 font-medium" data-id="element-132">
              Una guía psicopedagógica donde descubrirás:
            </p>

            <ul className="space-y-5 mb-10" data-id="element-133">
              {['por qué los niños se distraen fácilmente', 'cómo funciona el aprendizaje infantil', 'qué factores influyen en la concentración', 'cómo acompañar las tareas escolares sin conflictos', 'estrategias para estimular la motivación y el interés'].map((item, index) => <li key={index} className="flex items-start" data-id="element-134">
                  <ChevronRight className="h-6 w-6 text-yellow-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-135" />
                  <span className="text-lg md:text-xl text-gray-100" data-id="element-136">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="bg-gray-700/50 border border-gray-600 rounded-xl p-6 text-center" data-id="element-137">
              <p className="text-xl font-bold text-yellow-400" data-id="element-138">
                Un material claro y práctico para aplicar desde casa.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}